import {
  KeyLikelihoodFactorsDocument,
  KeyLikelihoodFactorsSummariesDocument,
  type KeyLikelihood,
} from "$/__generated__/graphql";
import { OverviewDataTables } from "components/tables";
import {
  KEY_LIKELIHOOD_FACTORS_BASE_DEFS,
  KEY_LIKELIHOOD_FACTORS_ROUNDING,
} from "constants/column-defs";
import { useGlobalFiltersContext } from "contexts/filters";
import {
  useDataTable,
  useDataTableSummaries,
  useSummariesFormatters,
} from "hooks/queries";
import { useAppliedColumns } from "hooks/useAppliedColumns";

export const SystemOverviewKLF = () => {
  const { hierarchyIds } = useGlobalFiltersContext();

  const {
    showFoot,
    systemMetric,
    selectionMetric,
    setSelectionMetric,
    setSystemMetric,
    setShowFoot,
    rows,
    loading,
    fetchMoreDataTable,
    isFetchingMore,
  } = useDataTable<KeyLikelihood>(
    "keyLikelihoodFactors",
    KeyLikelihoodFactorsDocument,
    {
      variables: {
        hierarchyIds,
      },
    },
  );

  const appliedColumns = useAppliedColumns<KeyLikelihood>(
    "KeyLikelihoodFactors",
    KEY_LIKELIHOOD_FACTORS_BASE_DEFS,
  );

  const { columns } = useDataTableSummaries(
    appliedColumns,
    KeyLikelihoodFactorsSummariesDocument,
    {
      variables: {
        hierarchyIds,
        selectionMetricType: selectionMetric,
        systemMetricType: systemMetric,
      },
    },
    useSummariesFormatters(
      selectionMetric,
      systemMetric,
      KEY_LIKELIHOOD_FACTORS_ROUNDING,
    ),
  );

  return (
    <OverviewDataTables
      loading={loading}
      data={rows}
      columns={columns}
      selectionValue={selectionMetric}
      systemValue={systemMetric}
      showFoot={showFoot}
      onSelectionChange={setSelectionMetric}
      onSystemChange={setSystemMetric}
      setShowFoot={setShowFoot}
      onFetchMore={fetchMoreDataTable}
      isFetchingMore={isFetchingMore}
    />
  );
};

export default SystemOverviewKLF;
